import { ExtensionType } from '@pixi/core';
import { Spritesheet } from '@pixi/spritesheet';
import type { LoadAsset, LoaderParser } from '@pixi/assets';
import { PyxelFile } from 'engine/Fileschemes/PyxelFile';

/**
 * Loader plugin that turns sprite sheets from pyxel files into a {@link PyxelFile}.
 */
export const loadPyxel = {
	extension: ExtensionType.LoadParser,

	async testParse(asset: any, options: LoadAsset): Promise<boolean> {
		return asset instanceof Spritesheet && (asset.data.meta as any).pyxel;
	},

	async parse(asset: Spritesheet): Promise<PyxelFile> {
		return new PyxelFile(asset);
	},

	unload(spritesheet: PyxelFile) {
		// TODO
		// spritesheet.destroy(true);
	},

} as LoaderParser;
